import { Component, OnInit, Input } from '@angular/core'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import { ChannelReviewSources, getChannelReviewSource } from '@tokeet-frontend/reviews'

@Component({
  selector: 'app-booking-review',
  template: `
    <app-vrbo-booking-review
      *ngIf="reviewSource === channelReviewSource.Vrbo"
      [inquiry]="inquiry"
    ></app-vrbo-booking-review>
    <app-airbnb-booking-review
      *ngIf="reviewSource === channelReviewSource.Airbnb"
      [inquiry]="inquiry"
    ></app-airbnb-booking-review>
    <app-bdc-booking-review
      *ngIf="reviewSource === channelReviewSource.BookingCom"
      [inquiry]="inquiry"
    ></app-bdc-booking-review>
    <app-expedia-booking-review
      *ngIf="reviewSource === channelReviewSource.Expedia"
      [inquiry]="inquiry"
    ></app-expedia-booking-review>
  `,
})
export class BookingReviewComponent implements OnInit {
  @Input() inquiry: Inquiry

  get reviewSource() {
    return getChannelReviewSource(this.inquiry.inquirySource)
  }

  channelReviewSource = ChannelReviewSources

  ngOnInit(): void {}
}
